<template>
  <b-modal
    id="kanbangivefdbck"
    centered
    hide-footer
    hide-header
    no-close-on-backdrop
    size="md"
    :visible="isMoveToFinal"
    @hidden="$emit('close-modal')"
  >
    <div class="w-100">
      <div class="p-3 d-flex justify-content-between align-items-center">
        <div class="pff-modal-heading">Move To Final</div>
        <div class="pointer" @click="$emit('close-modal')">
          <img
            class="rotate-on-hover"
            src="../../../assets/img/feedbackform/x-close.svg"
            alt=""
          />
        </div>
      </div>
    </div>
    <hr class="m-0" />
    <div class="p-3">
      <SingleSelectSearch
        :label="'Approver (To select this candidate for final selection)'"
        :mandatory="true"
        :showError="$v.selectedOpsHead.$error"
        :opsHeadList="opsHeadList"
        @search-data="searchOpsHead"
        @select-value="selOpsHead"
      />

      <div class="newmodalinputbox mt-3">
        <div class="jdk-ip-confirm-subtxt">
          Remarks<span class="asterik">*</span>
        </div>
        <b-form-textarea
          class="overflow-auto"
          rows="2"
          type="text"
          max-rows="5"
          placeholder="Enter"
          v-model.trim="$v.feedback.recruiterRemarks.$model"
          :class="$v.feedback.recruiterRemarks.$error ? 'error' : ''"
        >
        </b-form-textarea>
        <div
          v-if="
            $v.feedback.recruiterRemarks.$dirty &&
            !$v.feedback.recruiterRemarks.required
          "
          class="errortxt position-absolute"
        >
          Required
        </div>
        <div
          v-else-if="!$v.feedback.recruiterRemarks.maxLength"
          class="errortxt position-absolute"
        >
          Exceeded the max char length of 256
        </div>
      </div>
    </div>
    <div
      class="
        d-flex
        align-items-center
        justify-content-end
        p-2
        bluebtn
        mt-2
        mb-2
      "
    >
      <b-button
        class="acs-cancelBtn-modal w-105px mr-3"
        @click="$emit('close-modal')"
        >Cancel</b-button
      >
      <div class="position-relative">
        <b-button
          class="acs-addBtn-modal w-105px"
          :class="{
            'FS-loader-class': feedback.recommendation != 'FS' && showLoader,
            defaultCursor: showLoader,
            pointer: !showLoader,
          }"
          @click="showLoader ? '' : confirm()"
          >{{ showLoader ? "" : "Send for approval" }}</b-button
        >
        <div v-if="showLoader" class="FS-loader-pos">
          <Loader />
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { required, maxLength } from "vuelidate/lib/validators";
import { getOpsHead, movetofinalround } from "../../../utils/apiFunctions";
import { mapGetters } from "vuex";
import Loader from "../../fixedcomponents/Loader.vue";
import toast from "../../mixin/toast";
import SingleSelectSearch from "../../InputComponents/SingleSelectSearch.vue";
export default {
  name: "MoveToFinal",
  data() {
    return {
      opsHeadSearch: "",
      selectedOpsHead: {},
      showOpsHead: false,
      showLoader: false,
      opsHeadList: [],

      feedback: {
        recommendation: "",
        recruiterRemarks: "",
      },
    };
  },
  props: {
    isMoveToFinal: Boolean,
    selectedProcess: Object,
    selectedCandidate: Object,
    particularJob: Object,
  },
  mixins: [toast],
  components: {
    Loader,
    SingleSelectSearch,
  },
  computed: {
    ...mapGetters("userVUEX", {
      roleValues: "getRoleValues",
      licenseKey: "getlicenseKey",
    }),
    ...mapGetters(["roles"]),
  },
  validations() {
    return {
      feedback: {
        recruiterRemarks: {
          required,
          maxLength: maxLength(256),
        },
      },
      selectedOpsHead: {
        required,
      },
    };
  },
  created() {
    this.getOpsHead();
  },
  methods: {
    searchOpsHead(value) {
      this.opsHeadSearch = value;
      this.getOpsHead();
    },
    selOpsHead(opsHead) {
      this.selectedOpsHead = opsHead;
      this.$forceUpdate();
    },
    async getOpsHead() {
      let payload = {
        licenseKey: this.licenseKey,
        searchQuery: this.opsHeadSearch,
      };
      const res = await getOpsHead(payload);
      if (res.status == 200) {
        this.opsHeadList = res.data.data;
        this.$forceUpdate();
      }
    },
    async confirm() {
      this.$v.feedback.$touch();
      this.$v.selectedOpsHead.$touch();

      if (!this.$v.feedback.$invalid && !this.$v.selectedOpsHead.$invalid) {
        this.showLoader = true;
        let payload = {
          candidateID: this.selectedCandidate.candidateID,
          customerID: this.particularJob.customerID,
          jobID: this.particularJob.jobID,
          approverUserID: this.selectedOpsHead.userID,
          recruiterRemarks: this.feedback.recruiterRemarks,
        };

        const res = await movetofinalround(payload);
        if (res.status == 200) {
          var text = `Candidate "${this.selectedCandidate.name}" has been sent for approval.`;
          this.dynamicToast("feedbacksent", `Successfully sent feedback`, text);
          this.$emit("update-details");
          this.$emit("close-modal");
        } else if (res.status == 409) {
          this.errorModal(res.data.data.Detail);
        } else {
          this.errorModal("Something went wrong!");
        }
        this.showLoader = false;
      }
    },
  },
};
</script>

<style>
.recomendation-error .custom-control-label::before {
  border: 1px solid red;
}
.FS-loader-class {
  opacity: 0.5;
  height: 29px;
  width: 164px;
}
.FS-loader-pos {
  position: absolute;
  top: -54px;
  z-index: 1;
  left: 38px;
}

.resend-loader-class {
  opacity: 0.5;
  height: 29px;
  width: 96px;
}
.resend-loader-pos {
  position: absolute;
  top: -54px;
  z-index: 1;
  left: 0px;
}
.kanban-upload-failed-text {
  text-align: center;
  top: 60px;
  color: #eb0002;
  font-family: Lato;
  font-size: 16px;
  font-weight: 500;
}
</style>
